module.exports = __webpack_public_path__ + "static/media/table1.bb13aca1.svg";